<mat-radio-group fxFlexLayout="row" [(ngModel)]="option" (change)="setOption()" required name="criteriaRadiofieldType">
  @for (item of suggestions; track item) {
    <mat-radio-button [value]="item.id">{{ "visits.criteriaProperties." + item.displayName | translate }}</mat-radio-button>
  }
</mat-radio-group>
